import { useState } from "react";
import { gql, useReactiveVar } from "@apollo/client";
import { API, Storage } from "aws-amplify";

import { Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { POByNumber } from "../query";
import { ShippingByNumber } from "../../shippings/query";
import mergeArrayAndCombineQty from "../../../../lib/mergeArrayAndCombineQty";
import { toChinaDateString } from "../../../../lib/chinaDate";
import { userEntityRelationVar } from "../../../../client/cache";

import { onCreateShippings } from "../../shippings/onCreate";
import {
  bolNumberForItem,
  braunShippingListMeta,
  saveShippingList,
} from "../../shippings/saveShippingList";

export const navigateTo = "../shippings";

export const Bar = ({ rows }) => {
  return (
    <Stack direction="row" sx={{ alignSelf: "flex-start" }}>
      {rows?.length > 0 && (
        <Typography variant="h6">
          Total Qty: {rows?.reduce((a, v) => a + v.qty, 0)}
        </Typography>
      )}
    </Stack>
  );
};

function FileLine({ filename, entityID }) {
  const [isLoading, setIsloading] = useState(false);

  const path = `${entityID}/template/${filename}`;

  return (
    <Stack direction="row" justifyContent="space-between" spacing={1}>
      <Typography variant="p">{filename}</Typography>
      <LoadingButton
        loading={isLoading}
        size="small"
        onClick={async () => {
          setIsloading(true);
          try {
            const fetchedURL = await Storage.get(path, {
              download: false,
              validateObjectExistence: true,
              // level: 'protected',
            });
            window.location.href = fetchedURL;

            // console.log({window})

            // const downloadFolder = window.downloads.getDownloadFolder();

            // console.log({ downloadFolder });
            // debugger;
          } catch (err) {
            console.log({ err444: err });
          }
          setIsloading(false);
        }}
        variant="contained"
      >
        download
      </LoadingButton>
    </Stack>
  );
}

export const TemplateLabel = ({ rows }) => {
  const { entityID } = useReactiveVar(userEntityRelationVar);

  const filenames = ["BRAUN_TEMPLATE_SHIPPING.xlsx", "国内送货单导入模板.xls"];

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Template: </Typography>

      <Stack spacing={1}>
        {filenames.map((filename) => (
          <FileLine key={filename} filename={filename} entityID={entityID} />
        ))}
      </Stack>
    </Stack>
  );
};

export const headerIdentifier = [
  { label: "number", isRequired: false },
  { label: "itemNumber", isRequired: false },
  { label: "DOCUMENT", isRequired: true },
  { label: "poOpenQty", isRequired: false },
  { label: "MATERIAL", isRequired: true },
  { label: "OPEN QUANTITY", isRequired: true },
  { label: "SUPPLIER DELIV.DATE", isRequired: false },
  { label: "ETA PLANT", isRequired: false },
];

export async function onCreate({ rows, definerID, client }) {
  const number = rows[0].number;
  const date = toChinaDateString(rows[0].date);

  // console.log({ dateinOnCreate: date });

  const aggregatedShippingItems = rows.map((row) => {
    const { itemNumber, materialID, materialEntityRelationID, poID } = row;
    return {
      itemNumber,
      materialID,
      materialEntityRelationID,
      poID,
      qty: row["OPEN QUANTITY"],
    };
  });

  const values = {
    date,
    number,
    definerID,
    aggregatedShippingItems,
  };
  await onCreateShippings({ client, values, type: "OUTGOING" });

  const meta = {
    ...braunShippingListMeta,
    date,
    shippingNumber: number,
  };
  const { data } = await client.query({
    query: gql(ShippingByNumber),
    variables: { number },
  });

  const shippingItems = data?.ShippingByNumber?.items?.map((item, i) => {
    let poNumber = item?.po?.no;

    if (poNumber.includes("-")) {
      poNumber = poNumber.split("-")[1];
    }

    return {
      id: item?.id,
      poNumber,
      itemNumber: item?.itemNumber,
      qty: item?.qty,
      mpn: item?.material?.mpn,
      mfr: item?.material?.mfr,
      materialID: item?.material?.id,
      specifications: item?.material?.specifications,
      code: item?.materialEntityRelation?.code,
      palletQty: item?.qty,
      packageQty: item?.qty,
      remainder: 0,
      number: bolNumberForItem(number, item?.itemNumber),
    };
  });

  shippingItems.sort((a, b) => (a.itemNumber * 1 > b.itemNumber * 1 ? 1 : -1));

  await saveShippingList({ data: { meta, items: shippingItems } });

  await sendCOAPreview({ shippingItems, date });
}

export async function validator({ rows, definerID, client }) {
  let date = rows[0]["SUPPLIER DELIV.DATE"] || rows[0]["ETA PLANT"];
  const chinaDate = toChinaDateString(date);
  const [year, month, day] = (chinaDate || "").split("-");

  let serial = 1;
  const number = `SHJH${year}${month}${day}0${serial}`;

  let newarr = await Promise.all(
    rows?.map(async (row) => {
      let ERROR = [];
      const { MATERIAL, DOCUMENT } = row;
      const qty = row["OPEN QUANTITY"] * 1;

      if (DOCUMENT) {
        const PONumber = `A6P-${DOCUMENT}`;
        const { data } = await client.query({
          query: gql(POByNumber),
          variables: { number: PONumber, itemNumber: { eq: "00010" } },
        });
        const poFound = data?.POByNumber?.items?.[0];

        // console.log({ poFound })

        if (!poFound) {
          ERROR.push({
            attr: "DOCUMENT",
            isMajor: true,
            msg: "PO not found",
          });
          return { ...row, ERROR };
        }

        const {
          id,
          materialID,
          materialEntityRelationID,
          materialEntityRelation,
          openQty,
        } = poFound;

        if (materialEntityRelation.code !== MATERIAL) {
          ERROR.push({
            attr: "MATERIAL",
            isMajor: true,
            msg: "PO AND MATERIAL DO NOT MATCH",
          });
          return { ...row, ERROR };
        }

        if (openQty < qty) {
          ERROR.push({
            attr: "OPEN QUANTITY",
            isMajor: true,
            msg: "PO OPEN QUANTITY IS LESS THAN SHIPPING QTY",
          });
          return { ...row, ERROR };
        }
        row.poID = id;
        row.materialID = materialID;
        row.materialEntityRelationID = materialEntityRelationID;
        row.poOpenQty = openQty;
        row.qty = qty;
        row.PONumber = PONumber;
        row.number = number;
        row.date = chinaDate;
      }

      return { ...row, ERROR };
    })
  );

  newarr = mergeArrayAndCombineQty(newarr, ["poID"], ["qty"])
    .sort((a, b) => (a.PONumber > b.PONumber ? -1 : 1))
    .sort((a, b) => (a.MATERIAL > b.MATERIAL ? 1 : -1))
    ?.map((x, i) => ({
      ...x,
      // itemNumber: ((i + 1) * 10).toString().padStart(5, '0'),
      itemNumber: i + 1,
    }));

  return newarr;
}

async function sendCOAPreview({ shippingItems, date }) {
  let items = mergeArrayAndCombineQty(shippingItems, ["materialID"], ["qty"]);
  const formID = Date.now().toString().slice(1, 9);
  items.forEach((x, i) => {
    if (!x.specifications || x.specifications?.length === 0) {
      return alert(`${x.code} spec not found`);
    }
    x.formID = `${formID}-${i + 1}`;
  });

  items = items.map((x) => ({
    formID: x.formID,
    specifications: x.specifications,
    qty: x.qty,
    mfr: x.mfr,
    mpn: x.mpn,
    code: x.code,
  }));
  const meta = {
    date,
    // vendorPhoneNumber: "+86-21-50595180",
    to: null,
    // cc: null,
    bcc: "steven.lu@hankeno.com",
    sendList: true,

    // isPreview: true,
    // vendorName: "HANKENO ELECTRONICS (SHANGHAI) CO., LTD",
    // vendorAddress:
    //   "3/F, BLDG 2, CHANGZHENG INDUSTRIAL PARK, ALLEY 1225, TONGPU RD, PUTUO DISTRICT, SHANGHAI, PRC",
    // inspectedBy: "TONY LIU",
    // verifiedBy: "JAMES LEUNG",
  };
  try {
    const res = await API.post("iSupplyAPI", "/restricted", {
      body: {
        operation: "SEND_COA",
        data: {
          meta,
          items,
        },
      },
    });
    console.log({ res });
  } catch (err) {
    console.log({ error3333: err });
  }
}
